export default __webpack_public_path__ + "static/media/plinko.6afff8bf.webp";